module.exports = __webpack_public_path__ + "static/media/check-mark.2b60664d.png";